import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {InvoiceDiscountForm, InvoiceRowForm} from '../../core/_models'
import {fixZero, isNotEmpty, numberWithCommas} from '../../../../../../../_metronic/helpers'
import clsx from 'clsx'
import {CustomInputs} from '../../../../../../../_metronic/helpers/components/CustomInputs'
import {
  SearchSelect,
  SearchSelectOption,
} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import {useListView} from '../../core/ListViewProvider'
import {ProductEditModal} from '../../../../product-management/products-list/product-edit-modal/ProductEditModal'
import {getProductById} from '../../../../product-management/products-list/core/_requests'
import {Product} from '../../../../product-management/products-list/core/_models'

type Props = {
  discountItem: {
    discountItem: InvoiceDiscountForm | null | undefined
    setDiscountItem: React.Dispatch<React.SetStateAction<InvoiceDiscountForm | null | undefined>>
  }
  discounts: {
    discounts: InvoiceDiscountForm[]
    setDiscounts: Dispatch<SetStateAction<InvoiceDiscountForm[]>>
  }
  sumAdPrice: number
}

const InvoiceDiscountEditModalForm: FC<Props> = ({discountItem, discounts, sumAdPrice}) => {
  const {variableD} = useListView()
  const [first, setFirst] = useState(true)
  const [loaded, setLoaded] = useState(
    !(discountItem.discountItem && isNotEmpty(discountItem.discountItem))
  )
  const [description, setDescription] = useState<string>('')
  const [rate, setRate] = useState<string>('')
  const [price, setPrice] = useState<number>(0)
  const [type, setType] = useState<'rate' | 'price'>('price')
  useEffect(() => {
    if (first) {
      if (discountItem.discountItem && isNotEmpty(discountItem.discountItem)) {
        setDescription(discountItem.discountItem.description)
        setRate(discountItem.discountItem.rate)
        setType(discountItem.discountItem.type)
        setPrice(discountItem.discountItem.price || 0)
        setLoaded(true)
      }
      setFirst(false)
    }
  }, [])

  useEffect(() => {
    if (type == 'price' && loaded) {
      if (variableD == 4 && discountItem.discountItem && price > discountItem.discountItem.price) {
        setPrice(discountItem.discountItem.price)
        return
      }
      if (price > sumAdPrice) {
        setPrice(sumAdPrice)
      }
      if (price <= 0) {
        setPrice(1)
      }
      setRate('')
    }
  }, [price])

  useEffect(() => {
    if (isNotEmpty(rate)) {
      if (
        variableD == 4 &&
        discountItem.discountItem &&
        Number(rate) > Number(discountItem.discountItem.rate)
      ) {
        setRate(discountItem.discountItem.rate)
        return
      }
      if (type == 'rate' && loaded) {
        if (Number(rate) > 100) {
          setRate('100')
        }
        if (Number(rate) < 0) {
          setRate('0')
        }
        setPrice(fixZero(sumAdPrice * (Number(rate) / 100)))
      }
    }
  }, [rate])

  const save = () => {
    const id =
      discountItem.discountItem && isNotEmpty(discountItem.discountItem)
        ? discountItem.discountItem.id
        : fixZero(Math.random() * 952413) * -1
    const newValue: InvoiceDiscountForm = {
      id: id,
      description: description,
      type: type,
      rate: rate,
      price: price,
    }
    if (discounts.discounts) {
      const ind = discounts.discounts.findIndex((x) => x.id == id)
      if (ind >= 0) {
        discounts.discounts.splice(ind, 1)
      }
      discounts.setDiscounts([newValue, ...discounts.discounts])
    } else {
      discounts.setDiscounts([newValue, ...[]])
    }
    discountItem.setDiscountItem(undefined)
  }

  return (
    <>
      <div className='row'>
        <div className='col-12 mt-5'>
          <CustomInputs
            label='شرح تخفیف'
            isRequired
            type='text'
            stateValue={{value: description, setValue: setDescription}}
          />
        </div>
        <div className='col-6 mt-5'>
          <CustomInputs
            label='درصد تخفیف'
            isDisabled={
              variableD == 4 &&
              discountItem.discountItem != undefined &&
              discountItem.discountItem != null &&
              Number(discountItem.discountItem.rate) <= 0
            }
            type='number'
            stateValue={{value: rate, setValue: setRate}}
            onKeyDownFn={() => setType('rate')}
          />
        </div>
        <div className='col-6 mt-5'>
          <CustomInputs
            label='مبلغ تخفیف'
            isRequired
            type='currency'
            stateValue={{value: price, setValue: setPrice}}
            onKeyDownFn={() => setType('price')}
          />
        </div>
      </div>

      {/* begin::Actions */}
      <div className='text-center pt-15'>
        <button
          onClick={() => discountItem.setDiscountItem(undefined)}
          className='btn btn-light me-3'
          data-kt-invoices-modal-action='cancel'
        >
          بستن
        </button>

        <button
          disabled={
            !(isNotEmpty(price) && isNotEmpty(description) && description.trim() != '' && price > 0)
          }
          className='btn btn-success'
          onClick={save}
        >
          <span className='indicator-label'>ذخیره</span>
        </button>
      </div>
      {/* end::Actions */}
    </>
  )
}

export {InvoiceDiscountEditModalForm}
